import {handleResponse, handleError, headerset} from "../apiUtils";
import {Ticket, Commento} from "../../components/ticketing/ticketingSlice";

import {convertToDateTime} from "../../components/common/dateUtils/convertToDateTime";
import {getParametriTicketingApi, ParametriTicketing} from "./getParametriTicketingApi";

export async function fetchTickets(
    autore_id?: number,
    owner_id?: number,
    listaStati?: string[],
    priorita?: string,
    numero_record?: number,
    page?: number,
    search?: string
) {
    const parametriTicketing: ParametriTicketing = await getParametriTicketingApi();
    let url = parametriTicketing.url + "/api/ticketing/";
    if (
        autore_id != undefined ||
        owner_id != undefined ||
        (listaStati && listaStati?.length > 0) ||
        priorita != undefined ||
        numero_record != undefined ||
        search != undefined ||
        page != undefined
    ) {
        url += "?";
    }
    if (autore_id != undefined) {
        url += `autore_id=${autore_id}&`;
    }
    if (owner_id != undefined) {
        url += `owner_id=${owner_id}&`;
    }
    if ((listaStati && listaStati?.length > 0)) {
        url += `lista_stati=${listaStati.join(",")}&`;
    }
    if (priorita != undefined) {
        url += `priorita=${priorita}&`;
    }
    if (numero_record != undefined) {
        url += `numero_record=${numero_record}&`;
    }
    if (page != undefined) {
        url += `page=${page}&`;
    }
    if (search != undefined) {
        url += `search=${search}`;
    }
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: parametriTicketing.authorization || "",
        },
    })
        .then(handleResponse)
        .catch(handleError);
}


export function conteggioTicketsAttivi(
    autore?: number,
    assegnato_a?: number,
) {
    let url = process.env.API_URL + "/api/ticketing/conteggio_tickets_attivi/";
    if (
        autore != undefined ||
        assegnato_a != undefined
    ) {
        url += "?";
    }
    if (autore != undefined) {
        url += `autore=${autore}&`;
    }
    if (assegnato_a != undefined) {
        url += `assegnato_a=${assegnato_a}&`;
    }
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export async function getTicket(ticketId: number) {
    const parametriTicketing: ParametriTicketing = await getParametriTicketingApi();
    const url = parametriTicketing.url + `/api/ticketing/${ticketId}/`;
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: parametriTicketing.authorization || "",
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export async function saveTicket(ticketToSave: Ticket, azione?: string, autore_descrizione?: string) {
    const parametriTicketing: ParametriTicketing = await getParametriTicketingApi();
    let url = parametriTicketing.url + `/api/ticketing/`;
    if (ticketToSave.id) {
        url += ticketToSave.id + "/";
        if (azione || autore_descrizione) {
            url = url + `?`;
        }
        if (azione) {
            url = url + `azione=${azione}&`;
        }
        if (autore_descrizione) {
            url = url + `autore_descrizione=${autore_descrizione}`;
        }
    }
    // else {
    //     if(ordine){
    //         url =
    //             process.env.API_URL +
    //             `/api/ordini/${taskToSave.ordine}/aggiungi_task/`;
    //     }
    // }

    const data_apertura = ticketToSave.data_apertura
        ? convertToDateTime(ticketToSave?.data_apertura)
            ?.setLocale("it")
            .toFormat("yyyy-MM-dd")
        : null;

    const ticket = {
        ...ticketToSave,
        data_apertura: data_apertura,
        // applicativo: parametriTicketing.applicativo,
    };
    return fetch(url, {
        method: ticketToSave.id ? "PUT" : "POST", // PUT to update when id already exists.
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: parametriTicketing.authorization || "",
        },
        body: JSON.stringify({
            ...ticket,
            // Parse authorId to a number (in case it was sent as a string).
            // id: parseInt(progetto.id, 10),
        }),
    })
        .then(handleResponse)
        .catch(handleError);
}

export async function deleteTicket(ticketToDelete: Ticket) {
    const parametriTicketing: ParametriTicketing = await getParametriTicketingApi();
    const url = parametriTicketing.url + "/api/ticketing/" + ticketToDelete.id + "/";
    return fetch(url, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: parametriTicketing.authorization || "",
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

export async function saveCommento(commentoToSave: Commento, azione?: string) {
    const parametriTicketing: ParametriTicketing = await getParametriTicketingApi();
    let url =
        parametriTicketing.url +
        "/api/ticketing/" +
        commentoToSave.ticket +
        "/commenti/";

    if (commentoToSave.id) {
        url += commentoToSave.id + "/";
        if (azione) {
            url = url + `?azione=${azione}`;
        }
    }

    const commento = {
        ...commentoToSave,
        // data: data,
    };
    return fetch(url, {
        method: commentoToSave.id ? "PUT" : "POST", // PUT to update when id already exists.
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: parametriTicketing.authorization || "",
        },
        body: JSON.stringify({
            ...commento,
            // Parse authorId to a number (in case it was sent as a string).
            // id: parseInt(progetto.id, 10),
        }),
    })
        .then(handleResponse)
        .catch(handleError);
}

// export function deleteCommento(commentoToDelete: Commento) {
//     const url =
//         process.env.API_URL +
//         "/api/ticketing/commenti/" +
//         commentoToDelete.id +
//         "/";
//     return fetch(url, {
//         method: "DELETE",
//         headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: headerset().Authorization,
//         },
//     })
//         .then(handleResponse)
//         .catch(handleError);
// }

